import { Component, OnInit, DoCheck, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../services/language.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {

  languages = [];
  showLanguageSelector = false;

  @Input() from: string;

  constructor(public languageService: LanguageService, private userService: UserService) { }

  async ngOnInit(): Promise<void> {
    try {

      // Esperamos a que la lista de idiomas se cargue
      this.languages = await this.languageService.getLanguageList();

      if (this.languages.length > 1) {
        this.showLanguageSelector = true;
      }
    } catch (error) {
      console.error('Error al cargar idiomas:', error);
    }
  }

  changeLanguage(langCode: string): void {
    this.languageService.changeLanguage(langCode);
    if (this.from == "header") {
      this.userService.changeLanguage(langCode).subscribe(res => { });
    }
  }

  isCurrentLanguage(langCode: string): boolean {
    return this.languageService.getCurrentLanguage() === langCode;
  }
}
